module.exports = "/subscriptions/assets/20c831201aac84fd7d84995410eaba55.png";